import { createAction, props } from '@ngrx/store';
import {
  ParameterData,
  ParametersDataResponseRequest,
} from 'src/app/pages/admin-manager/parameters/models/parameters.model';

export const loadParameterDetails = createAction(
  '[Parameters] Load Parameters',
  props<{ request: ParametersDataResponseRequest[] }>(),
);

export const loadParametersSuccess = createAction(
  '[Parameters] Load Parameters Success',
  props<{ response: ParameterData[]; request: ParametersDataResponseRequest[] }>(),
);

export const loadParametersFailure = createAction(
  '[Parameters] Load Parameters Failure',
  props<{ error: any; request: ParametersDataResponseRequest[] }>(),
);

export const saveRequestedParameters = createAction(
  '[Parameters] Save Requested Parameters',
  props<{ request: ParametersDataResponseRequest[] }>(),
);

export const removeRequestedParameters = createAction(
  '[Parameters] Remove Requested Parameters',
  props<{ request: ParametersDataResponseRequest[] }>(),
);

export const retryLoadParameters = createAction('[Parameters] Retry Load Parameters');

export const refreshLoadParameters = createAction('[Parameters] Refresh Load Parameters');
export const refreshLoadParametersSuccess = createAction(
  '[Parameters] Refresh Endpoint Success',
  props<{ response: ParameterData[]; request: ParametersDataResponseRequest[] }>(),
);

export const removeRequestedDisabledParameters = createAction(
  '[Parameters] Remove Requested Disabled Parameters',
  props<{ request: ParametersDataResponseRequest[] }>(),
);
